import type { GridFilterModel, GridFilterItem } from '@mui/x-data-grid/models';
import { filterItemEquals, makeQuickFilterItem, findInQuickFilter } from '@cbridge-utils/datagrid';
import { IApiGetTriggeredAlertsReq } from '@cbridge-packages/api-notifications';
import { AlertType, AlertTranslator } from '@cbridge-packages/alert';
import {
  IAlertsDashboardFilter, AlertsDashboardColumnFilterNames, AlertsDashboardQuickFilterNames, ITriggeredAlertsKey,
} from './alertsDashboard.interface';

export namespace AlertsDashboardTranslator {

  export function toApiPayload(payload: ITriggeredAlertsKey): IApiGetTriggeredAlertsReq {
    return {
      excludeSkipped: payload.excludeSkipped,
      fromTimestamp: payload.fromTimestamp,
      limit: payload.limit,
      skip: payload.skip,
      toTimestamp: payload.toTimestamp,
      type: AlertTranslator.toApiAlertType(payload.type),
    };
  }

  export function toGridFilterModel(props: IAlertsDashboardFilter): GridFilterModel {
    const { type, fromTimestamp, toTimestamp, excludeSkipped } = props;

    const filterItems: GridFilterItem[] = type
      ? [filterItemEquals(AlertsDashboardColumnFilterNames.type, type)]
      : [];

    const quickFilterValues = [];
    if (fromTimestamp) {
      quickFilterValues.push(makeQuickFilterItem(AlertsDashboardQuickFilterNames.fromTimestamp, fromTimestamp));
    }
    if (toTimestamp) {
      quickFilterValues.push(makeQuickFilterItem(AlertsDashboardQuickFilterNames.toTimestamp, toTimestamp));
    }
    if (excludeSkipped !== undefined) {
      quickFilterValues.push(makeQuickFilterItem(AlertsDashboardQuickFilterNames.excludeSkipped, excludeSkipped));
    }

    return {
      items: filterItems,
      quickFilterValues: quickFilterValues.length > 0 ? quickFilterValues : undefined,
    };
  }

  export function fromGridFilterModel({ items, quickFilterValues }: GridFilterModel): IAlertsDashboardFilter {
    const type = items.find(({ field }) => field === AlertsDashboardColumnFilterNames.type)?.value as AlertType;
    const fromTimestamp = findInQuickFilter<number>(quickFilterValues, AlertsDashboardQuickFilterNames.fromTimestamp);
    const toTimestamp = findInQuickFilter<number>(quickFilterValues, AlertsDashboardQuickFilterNames.toTimestamp);
    const excludeSkipped = findInQuickFilter<boolean>(quickFilterValues, AlertsDashboardQuickFilterNames.excludeSkipped);

    return {
      type,
      fromTimestamp,
      toTimestamp,
      excludeSkipped,
    };
  }
}
